<template>
  <v-col cols="12" sm="6" md="5" class="py-0">
    <h3 class="mb-2 text-sm-subtitle-2">
      {{ $t("stayDates") }}
    </h3>
    <div class="d-flex">
      <date-range-picker
        ref="dateRangePicker"
        :label="$t('stayDatesLabel')"
        :item-dates="dates"
        :min="minDate"
        :max="maxDate"
        :fixed-range="0"
        :disabled="false"
        :disabled-dates="[]"
        :loading="false"
        @update:dates="dates = $event"
        @update:date-picker="dateRangePicker = $event"
      >
      </date-range-picker>
    </div>
  </v-col>
</template>

<script>
import { mapState } from "vuex";
import { format, addDays } from "date-fns";
import DateRangePicker from "@/components/formFields/DateRangePicker";

export default {
  name: "ChainStayDates",
  components: {
    DateRangePicker,
  },
  data: () => ({
    dateRangePicker: false,
    dates: [],
  }),
  computed: {
    maxDate() {
      let maxDate = format(addDays(new Date(), 546), "YYYY-MM-DD");
      return maxDate;
    },
    minDate() {
      let minDate = format(new Date(), "YYYY-MM-DD");
      if (this.dates.length === 1) {
        minDate = this.dates[0];
      }
      return minDate;
    },
    validRange() {
      return this.dates.length === 2 && this.dates[0] !== this.dates[1];
    },
    datesChanged() {
      return (
        this.dates[0] !== this.stayDates.arrivalDate ||
        this.dates[1] !== this.stayDates.departureDate
      );
    },
    dateRangeText() {
      const dates = this.dates;
      if (dates.length === 0) {
        return "";
      }
      if (dates.length === 2) {
        if (dates[0] > dates[1]) {
          dates.reverse();
        }
      }
      const formatter = new Intl.DateTimeFormat(this.language.locale, {
        day: "numeric",
        month: "short",
      });

      return dates.map((date) => formatter.format(new Date(date))).join(" ~ ");
    },
    ...mapState(["stayDates"]),
    ...mapState("language", ["language"]),
  },
  watch: {
    dateRangePicker(val) {
      if (!val) {
        if (this.validRange) {
          if (this.datesChanged) {
            this.$emit("dates-changed", this.dates);
          }
        } else {
          this.dates = JSON.parse(
            JSON.stringify([
              this.stayDates.arrivalDate,
              this.stayDates.departureDate,
            ])
          );
        }
      } else {
        this.dates = [];
      }
    },
    stayDates: {
      immediate: true,
      handler(val) {
        if (val) {
          this.dates = JSON.parse(
            JSON.stringify([val.arrivalDate, val.departureDate])
          );
        }
      },
    },
  },
};
</script>
